/* ================================================================
   Bundle Builder Inverno — vanilla JS, sem dependencies do tema.
   Escopo: APENAS a section sections/bundle-builder-inverno.liquid.
   Padrão de add to cart: replica blocks/pdp-bundle.liquid (batch
   fetch('/cart/add.js') sequencial + CartAddEvent quando disponivel).
   Memoria durável quick-add.js nativo do Horizon quebrado.
   ================================================================ */

(function () {
  if (window.BundleBuilderInverno) return;

  const SCOPE = 'bundle-builder-inverno';
  const SELECTORS = {
    root: `.${SCOPE}`,
    card: `[data-bbi-card]`,
    addBtn: `[data-bbi-add]`,
    variantSelect: `[data-bbi-variant-select]`,
    panel: `[data-bbi-panel]`,
    panelHandle: `[data-bbi-panel-handle]`,
    items: `[data-bbi-items]`,
    counterPieces: `[data-bbi-counter-pieces]`,
    counterLabel: `[data-bbi-counter-label]`,
    discountPill: `[data-bbi-discount-pill]`,
    contextualMsg: `[data-bbi-contextual-msg]`,
    totals: `[data-bbi-totals]`,
    totalCompareRow: `[data-bbi-total-compare-row]`,
    totalCompare: `[data-bbi-total-compare]`,
    totalFinal: `[data-bbi-total-final]`,
    totalSavings: `[data-bbi-total-savings]`,
    cta: `[data-bbi-cta]`,
    layout: `[data-bbi-layout]`,
    peek: `[data-bbi-peek]`,
    peekCount: `[data-bbi-peek-count]`,
    peekLabel: `[data-bbi-peek-label]`,
    peekPct: `[data-bbi-peek-pct]`,
  };

  function formatPercent(value) {
    // Inteiro vira "20"; decimal vira "22,5" (1 casa, virgula pt-BR).
    const n = Number(value) || 0;
    if (Number.isInteger(n)) return String(n);
    return n.toFixed(1).replace('.', ',');
  }

  function formatMoney(cents) {
    // Tenta usar Shopify.formatMoney quando disponivel; fallback BRL pt-BR
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      try {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      } catch (e) {
        // fallback abaixo
      }
    }
    const value = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    } catch (e) {
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }
  }

  class BundleBuilderInverno {
    constructor(root) {
      this.root = root;
      this.config = this.readConfig();
      this.products = this.readProducts();
      this.items = []; // [{key, variantId, productId, productHandle, productTitle, variantTitle, price, comparePrice, image, qty}]
      this.bindElements();
      this.bindEvents();
      this.render();
    }

    readConfig() {
      const c = this.root.dataset;
      return {
        discount1pcs: parseFloat(c.bbiDiscount1pcs ?? '0'),
        discount2pcs: parseFloat(c.bbiDiscount2pcs ?? '22'),
        discount3pcs: parseFloat(c.bbiDiscount3pcs ?? '24'),
        discount4pcsPlus: parseFloat(c.bbiDiscount4pcsplus ?? '27'),
        minPieces: parseInt(c.bbiMinPieces || '2', 10),
        maxPieces: parseInt(c.bbiMaxPieces || '0', 10),
        bundleTag: c.bbiBundleTag || 'inverno',
        ctaUrl: c.bbiCtaUrl || '/cart',
        copyEmpty: c.bbiCopyEmpty || 'Adicione produtos pra comecar a montar seu kit.',
        copyAddMore: c.bbiCopyAddMore || 'Adicione mais 1 peca e ganhe {X}% OFF',
        copyMinMissing: c.bbiCopyMinMissing || 'Adicione mais 1 peca pra comecar a economizar',
        copyMax: c.bbiCopyMax || 'Voce esta economizando o maximo!',
        copyCta: c.bbiCopyCta || 'Finalizar compra',
        cardBadgeText: c.bbiCardBadgeText || '{X}%',
      };
    }

    readProducts() {
      const dataEl = this.root.querySelector('[data-bbi-products-json]');
      if (!dataEl) return {};
      try {
        return JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        console.error('[BundleBuilderInverno] falha ao parsear products JSON', e);
        return {};
      }
    }

    bindElements() {
      this.els = {};
      Object.entries(SELECTORS).forEach(([key, sel]) => {
        if (key === 'root') {
          this.els[key] = this.root;
        } else {
          this.els[key] = this.root.querySelector(sel);
        }
      });
      this.els.addBtns = this.root.querySelectorAll(SELECTORS.addBtn);
      this.els.cards = this.root.querySelectorAll(SELECTORS.card);
    }

    bindEvents() {
      this.els.addBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => this.onAdd(e));
      });

      // Listener de troca de variante em cada card — atualiza imagem, preco e estado do botao
      this.els.cards.forEach((card) => {
        const selects = card.querySelectorAll(SELECTORS.variantSelect);
        selects.forEach((sel) => {
          sel.addEventListener('change', () => this.onVariantChange(card));
        });
        // Sincroniza estado inicial (preco/imagem default ja vem do Liquid, mas botao precisa refletir variant atual)
        this.onVariantChange(card);
      });

      if (this.els.items) {
        this.els.items.addEventListener('click', (e) => this.onItemAction(e));
      }

      if (this.els.cta) {
        this.els.cta.addEventListener('click', (e) => this.onCheckout(e));
      }

      // Toggle painel mobile (bottom sheet) via handle e via FAB
      if (this.els.panelHandle) {
        this.els.panelHandle.addEventListener('click', () => this.togglePanel());
      }
      if (this.els.peek) {
        this.els.peek.addEventListener('click', () => this.setPanelExpanded(true));
      }

      // Aniversário V7: carrinho mudou de faixa -> repinta a escada exibida
      document.addEventListener('aniv:discount-state', () => this.render());
    }

    togglePanel() {
      const current = this.els.panel && this.els.panel.getAttribute('data-expanded') === 'true';
      this.setPanelExpanded(!current);
    }

    setPanelExpanded(expanded) {
      const val = expanded ? 'true' : 'false';
      if (this.els.panel) {
        this.els.panel.setAttribute('data-expanded', val);
      }
      if (this.els.panelHandle) {
        this.els.panelHandle.setAttribute('aria-expanded', val);
      }
      if (this.els.layout) {
        this.els.layout.setAttribute('data-panel-expanded', val);
      }
    }

    resolveVariant(card) {
      const productHandle = card.dataset.bbiProductHandle;
      const product = this.products[productHandle];
      if (!product) return { product: null, variant: null };

      const selects = card.querySelectorAll(SELECTORS.variantSelect);
      const selectedOptions = Array.from(selects).map((s) => s.value);

      let variant;
      if (product.variants.length === 1) {
        variant = product.variants[0];
      } else if (selectedOptions.length === 0) {
        variant = product.variants.find((v) => v.available) || product.variants[0];
      } else {
        variant = product.variants.find((v) => {
          return selectedOptions.every((val, idx) => v.options[idx] === val);
        });
      }
      return { product, variant: variant || null };
    }

    onVariantChange(card) {
      const { product, variant } = this.resolveVariant(card);
      if (!product) return;

      const imgEl = card.querySelector('.bundle-builder-inverno__card-media img');
      const addBtn = card.querySelector(SELECTORS.addBtn);

      // Imagem: troca pra featured_image da variante quando existir; senao mantem a default do produto
      if (imgEl) {
        const variantImg = variant && variant.featured_image && variant.featured_image.src;
        const targetSrc = variantImg || product.featured_image || '';
        if (targetSrc && imgEl.src !== targetSrc) {
          // remove srcset pra evitar que o browser ignore o novo src
          if (imgEl.hasAttribute('srcset')) imgEl.removeAttribute('srcset');
          imgEl.src = targetSrc;
        }
      }

      // Preco: reescreve com o desconto da PROXIMA peca (mesma rotina do render
      // a cada add/remove) pra que trocar variante nao apague o badge.
      if (variant) {
        this.renderCardPrice(card, variant);
      }

      // Botao: desabilita se nao tem variant ou variant indisponivel
      if (addBtn) {
        const unavailable = !variant || variant.available === false;
        const labelEl = addBtn.querySelector('span');
        if (!variant) {
          addBtn.disabled = true;
          if (labelEl) labelEl.textContent = 'Indisponivel';
        } else if (unavailable) {
          addBtn.disabled = true;
          if (labelEl) labelEl.textContent = 'Esgotado';
        } else {
          addBtn.disabled = false;
          if (labelEl) labelEl.textContent = 'Adicionar';
        }
      }
    }

    // Reescreve o preco de UM card: preco cheio riscado + preco com o desconto
    // da proxima peca em destaque (bloco de preco) + selo de % sobre a imagem.
    // nextPct === 0 => preco normal limpo + selo escondido.
    renderCardPrice(card, variant) {
      if (!card || !variant) return;
      const priceEl = card.querySelector('.bundle-builder-inverno__card-price');
      const badgeEl = card.querySelector('[data-bbi-card-badge]');
      if (!priceEl) return;
      const nextPct = this.nextPiecePercent();

      if (nextPct <= 0) {
        priceEl.innerHTML = formatMoney(variant.price);
        if (badgeEl) {
          badgeEl.textContent = '';
          badgeEl.hidden = true;
        }
        return;
      }

      const discounted = Math.round(variant.price * (1 - nextPct / 100));
      priceEl.innerHTML =
        `<span class="bundle-builder-inverno__card-price-discounted">${formatMoney(discounted)}</span>` +
        `<span class="bundle-builder-inverno__card-compare-at">${formatMoney(variant.price)}</span>`;
      if (badgeEl) {
        badgeEl.textContent = this.config.cardBadgeText.replace('{X}', formatPercent(nextPct));
        badgeEl.hidden = false;
      }
    }

    // Reescreve o preco de TODOS os cards do pool conforme a proxima peca.
    // Chamado pelo render() a cada add/remove/qty.
    updateCardPricing() {
      this.els.cards.forEach((card) => {
        const { variant } = this.resolveVariant(card);
        if (!variant) return;
        this.renderCardPrice(card, variant);
      });
    }

    onAdd(e) {
      const btn = e.currentTarget;
      const card = btn.closest(SELECTORS.card);
      if (!card) return;

      const { product, variant } = this.resolveVariant(card);
      if (!product) {
        console.warn('[BundleBuilderInverno] produto nao encontrado:', card.dataset.bbiProductHandle);
        return;
      }
      if (!variant) {
        console.warn('[BundleBuilderInverno] variante nao encontrada pras opcoes selecionadas');
        return;
      }

      if (variant.available === false) {
        // visual feedback
        btn.setAttribute('data-state', 'unavailable');
        setTimeout(() => btn.removeAttribute('data-state'), 1500);
        return;
      }

      // Teto duro: nao ultrapassa maxPieces (defesa alem do disabled aplicado no render).
      if (this.atMaxPieces()) return;

      const key = String(variant.id);
      const existing = this.items.find((it) => it.key === key);
      if (existing) {
        existing.qty += 1;
      } else {
        this.items.push({
          key,
          variantId: variant.id,
          productId: product.id,
          productHandle: product.handle,
          productTitle: product.title,
          variantTitle: variant.title === 'Default Title' ? '' : variant.title,
          price: variant.price, // em cents
          comparePrice: variant.compare_at_price || null,
          image: variant.featured_image && variant.featured_image.src ? variant.featured_image.src : product.featured_image,
          qty: 1,
        });
      }

      // feedback visual
      btn.setAttribute('data-state', 'added');
      setTimeout(() => btn.removeAttribute('data-state'), 900);

      this.render();
    }

    onItemAction(e) {
      const target = e.target.closest('[data-bbi-qty-btn], [data-bbi-remove]');
      if (!target) return;
      const li = target.closest('[data-bbi-item]');
      if (!li) return;
      const key = li.dataset.bbiItem;
      const item = this.items.find((it) => it.key === key);
      if (!item) return;

      let targetQty;
      if (target.matches('[data-bbi-remove]')) {
        this.items = this.items.filter((it) => it.key !== key);
        targetQty = 0;
      } else if (target.matches('[data-bbi-qty-btn]')) {
        const dir = target.dataset.bbiQtyBtn;
        if (dir === 'inc') {
          if (this.atMaxPieces()) return; // teto duro atingido: ignora incremento
          item.qty += 1;
        } else if (dir === 'dec') {
          item.qty -= 1;
          if (item.qty <= 0) this.items = this.items.filter((it) => it.key !== key);
        }
        targetQty = item.qty > 0 ? item.qty : 0;
      }

      // Sync defensivo com cart real: se a variant ja' estiver no cart
      // (por add anterior), ajusta quantity. Se nao estiver, Shopify
      // retorna sem alterar — engulo silenciosamente.
      this.syncCartLine(item.variantId, targetQty);

      this.render();
    }

    syncCartLine(variantId, quantity) {
      // /cart/change.js aceita id = variantId (procura primeira linha com essa variant)
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: quantity }),
      })
        .then((res) => res.json().then((json) => ({ ok: res.ok, json })))
        .then(({ ok, json }) => {
          if (!ok) return; // variant nao esta no cart — no-op silencioso
          // Avisa o tema pra atualizar o drawer
          if (window.CartAddEvent) {
            try {
              document.dispatchEvent(new window.CartAddEvent({}, variantId, { source: 'bundle-builder-inverno' }));
            } catch (err) { /* silencioso */ }
          }
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'bundle-builder-inverno', cart: json } }));
        })
        .catch(() => { /* silencioso */ });
    }

    totalPieces() {
      return this.items.reduce((acc, it) => acc + it.qty, 0);
    }

    // Teto duro de pecas por instancia (config.maxPieces; 0 = ilimitado).
    // Quando atingido, trava o botao Adicionar e o + do painel. Instancias
    // sem max_pieces (default 0) nunca entram aqui — comportamento inalterado.
    atMaxPieces() {
      return this.config.maxPieces > 0 && this.totalPieces() >= this.config.maxPieces;
    }

    totalSubtotal() {
      // soma de price * qty
      return this.items.reduce((acc, it) => acc + (it.price * it.qty), 0);
    }

    totalCompare() {
      // soma compare_at_price quando existir; senao usa price
      return this.items.reduce((acc, it) => acc + ((it.comparePrice || it.price) * it.qty), 0);
    }

    discountPercent() {
      return this.discountForPieces(this.totalPieces());
    }

    // % que a PROXIMA peca adicionada ao kit teria, reusando a ladder.
    // Usado pra reescrever o preco de cada card como preview do beneficio.
    nextPiecePercent() {
      // No teto duro nao ha proxima peca: preview de preco dos cards volta ao normal.
      if (this.atMaxPieces()) return 0;
      return this.discountForPieces(this.totalPieces() + 1);
    }

    // Tabela irregular (lookup): 1pcs / 2pcs / 3pcs / 4+pcs (cap).
    // Abaixo de minPieces => 0 (mesmo que discount_Npcs > 0 no Theme Editor — minPieces gateia).
    discountForPieces(pieces) {
      // Aniversário V7: as peças pagas que já estão no carrinho contam pra escada
      // EXIBIDA (display-only; o desconto real é o do checkout). Escopado por
      // instância via data-bbi-cart-boost — os builders do perpétuo (collection.json
      // default, up-sell) NÃO herdam a lógica da campanha.
      const cartBoostOn = this.root.getAttribute('data-bbi-cart-boost') === 'true';
      const cartPieces = (cartBoostOn && window.AnivDesconto && window.AnivDesconto.ativo)
        ? (window.AnivDesconto.pecas || 0)
        : 0;
      pieces = pieces + cartPieces;
      if (pieces < this.config.minPieces) return 0;
      if (pieces === 1) return this.config.discount1pcs;
      if (pieces === 2) return this.config.discount2pcs;
      if (pieces === 3) return this.config.discount3pcs;
      return this.config.discount4pcsPlus; // 4+
    }

    // Cap exposto pra a copy "max" e checagem visual
    get discountCap() {
      return this.config.discount4pcsPlus;
    }

    /* 14/08/2026 — a COMPOSIÇÃO MORREU com o regime flat 15/32.
       Histórico do que existia aqui (03/08, PDF "Super review do site"): a escada exibida
       28/30/32 consolidava "nominal + 2% do Pix" numa soma, mas o motor multiplicava em
       duas etapas (regra do Admin e DEPOIS o Pix: x0,70 x0,98 = x0,686, não x0,68). O
       painel dizia R$1.905,09 e o carrinho R$1.921,90 pros mesmos 4 itens, e o gate
       `data-bbi-pix-compound` existia pra alinhar o display ao motor.
       Agora não há segunda etapa: a loja cobra 15% ou 32% e ponto, igual em qualquer
       forma de pagamento. Um desconto ÚNICO sobre o subtotal É o que o motor faz, então
       o caminho composto (e o gate que o ligava) deixaram de ter função. Removidos em vez
       de zerados: gate desligado ainda é código que alguém pode religar sem querer. */
    finalPrice() {
      const subtotal = this.totalSubtotal();
      const pct = this.discountPercent();
      return Math.round(subtotal * (1 - pct / 100));
    }

    render() {
      const pieces = this.totalPieces();
      const pct = this.discountPercent();
      const subtotal = this.totalSubtotal();
      const compare = this.totalCompare();
      const finalPrice = this.finalPrice();
      const savings = compare - finalPrice;

      // Preco dos cards reflete o desconto da proxima peca a cada mudanca
      this.updateCardPricing();

      // Teto duro: ao atingir maxPieces trava todos os botoes Adicionar; ao
      // voltar abaixo do teto restaura o estado por disponibilidade da variante.
      const atMax = this.atMaxPieces();
      this.els.cards.forEach((card) => {
        const addBtn = card.querySelector(SELECTORS.addBtn);
        if (!addBtn) return;
        if (atMax) {
          addBtn.disabled = true;
          addBtn.setAttribute('data-capped', 'true');
        } else if (addBtn.hasAttribute('data-capped')) {
          addBtn.removeAttribute('data-capped');
          this.onVariantChange(card);
        }
      });

      // Counter
      if (this.els.counterPieces) {
        this.els.counterPieces.textContent = pieces;
      }
      if (this.els.counterLabel) {
        this.els.counterLabel.textContent = pieces === 1 ? 'peca no bundle' : 'pecas no bundle';
      }

      // Discount pill. 14/08/2026: o "ATE" existia porque o X% embutia os 2% do Pix e
      // quem pagasse no cartao economizava menos. Sem composicao, o numero e exato pra
      // todo mundo — "ATE" viraria hedge de uma incerteza que nao existe mais.
      if (this.els.discountPill) {
        if (pct > 0) {
          this.els.discountPill.removeAttribute('data-state');
          this.els.discountPill.innerHTML = `<span>ECONOMIZE ${formatPercent(pct)}%</span>`;
        } else {
          this.els.discountPill.setAttribute('data-state', 'empty');
          this.els.discountPill.innerHTML = `<span>Sem desconto ainda</span>`;
        }
      }

      // Peek mobile (pill horizontal: badge + label contextual + %)
      if (this.els.peekLabel) {
        this.els.peekLabel.textContent = pieces === 0 ? 'MONTE SEU KIT' : 'VEJA SEU KIT';
      }
      if (this.els.peekCount) {
        this.els.peekCount.textContent = pieces;
        this.els.peekCount.hidden = pieces === 0;
      }
      if (this.els.peekPct) {
        this.els.peekPct.textContent = `${formatPercent(pct)}%`;
        this.els.peekPct.hidden = pct <= 0;
      }

      // Contextual message
      if (this.els.contextualMsg) {
        this.els.contextualMsg.removeAttribute('data-state');
        if (pieces === 0) {
          this.els.contextualMsg.textContent = this.config.copyEmpty;
        } else if (atMax) {
          this.els.contextualMsg.textContent = this.config.copyMax;
          this.els.contextualMsg.setAttribute('data-state', 'max');
        } else if (pieces < this.config.minPieces) {
          const missing = this.config.minPieces - pieces;
          this.els.contextualMsg.textContent = this.config.copyMinMissing
            .replace('{N}', missing)
            .replace('{X}', formatPercent(this.discountForPieces(this.config.minPieces)));
        } else if (pct >= this.discountCap) {
          this.els.contextualMsg.textContent = this.config.copyMax;
          this.els.contextualMsg.setAttribute('data-state', 'max');
        } else {
          const nextPct = this.discountForPieces(pieces + 1);
          this.els.contextualMsg.textContent = this.config.copyAddMore.replace('{X}', formatPercent(nextPct));
        }
      }

      // Aniversário V5 (Q&A#3 29/07): completou as 4 pecas -> painel realca (glow).
      const bbiMaxed = pieces > 0 && (pieces >= 4 || pct >= this.discountCap);
      this.root.classList.toggle('bbi-maxed', bbiMaxed);
      if (this.els.peekLabel && bbiMaxed) {
        this.els.peekLabel.textContent = 'FINALIZE SUA COMPRA';
      }

      // Items list
      if (this.els.items) {
        if (this.items.length === 0) {
          this.els.items.innerHTML = '';
          this.els.items.setAttribute('hidden', '');
        } else {
          this.els.items.removeAttribute('hidden');
          this.els.items.innerHTML = this.items.map((it) => this.renderItem(it)).join('');
        }
      }

      // Totals (bloco inteiro some quando lista vazia)
      if (this.els.totals) {
        if (pieces === 0) this.els.totals.setAttribute('hidden', '');
        else this.els.totals.removeAttribute('hidden');
      }

      // Subtotal riscado (so' quando ha desconto)
      if (this.els.totalCompareRow) {
        if (compare > finalPrice && pieces > 0) {
          this.els.totalCompareRow.removeAttribute('hidden');
        } else {
          this.els.totalCompareRow.setAttribute('hidden', '');
        }
      }
      if (this.els.totalCompare) {
        this.els.totalCompare.textContent = formatMoney(compare);
      }
      if (this.els.totalFinal) {
        this.els.totalFinal.textContent = formatMoney(finalPrice);
      }
      if (this.els.totalSavings) {
        if (savings > 0) {
          this.els.totalSavings.textContent = `Voce economiza ${formatMoney(savings)}`;
          this.els.totalSavings.removeAttribute('hidden');
        } else {
          this.els.totalSavings.setAttribute('hidden', '');
        }
      }

      // CTA — texto contextual: abaixo do minimo mostra "Adicione N pecas"; caso contrario texto padrao
      if (this.els.cta) {
        if (pieces < this.config.minPieces) {
          const missing = this.config.minPieces - pieces;
          const word = missing === 1 ? 'peca' : 'pecas';
          this.els.cta.textContent = `Adicione ${missing} ${word}`;
          this.els.cta.disabled = true;
        } else {
          // V5: com o kit fechado (4+ pecas) o CTA chama pra finalizar
          this.els.cta.textContent = bbiMaxed ? 'FINALIZE SUA COMPRA' : this.config.copyCta;
          this.els.cta.disabled = false;
        }
      }
    }

    renderItem(it) {
      const meta = it.variantTitle ? `<p class="bundle-builder-inverno__item-meta">${escapeHtml(it.variantTitle)}</p>` : '';
      const linePrice = formatMoney(it.price * it.qty);
      const incDisabled = this.atMaxPieces() ? 'disabled' : '';
      return `
        <li class="bundle-builder-inverno__item" data-bbi-item="${escapeAttr(it.key)}">
          <img class="bundle-builder-inverno__item-img" src="${escapeAttr(it.image || '')}" alt="${escapeAttr(it.productTitle)}" loading="lazy" width="48" height="48">
          <div class="bundle-builder-inverno__item-info">
            <p class="bundle-builder-inverno__item-title">${escapeHtml(it.productTitle)}</p>
            ${meta}
            <div class="bundle-builder-inverno__item-qty-price">
              <div class="bundle-builder-inverno__qty">
                <button type="button" class="bundle-builder-inverno__qty-btn" data-bbi-qty-btn="dec" aria-label="Diminuir quantidade">-</button>
                <span class="bundle-builder-inverno__qty-value">${it.qty}</span>
                <button type="button" class="bundle-builder-inverno__qty-btn" data-bbi-qty-btn="inc" aria-label="Aumentar quantidade" ${incDisabled}>+</button>
              </div>
              <span class="bundle-builder-inverno__item-price">${linePrice}</span>
            </div>
          </div>
          <button type="button" class="bundle-builder-inverno__remove-btn" data-bbi-remove aria-label="Remover item">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l8 8M11 3l-8 8"/></svg>
          </button>
        </li>
      `;
    }

    async onCheckout(e) {
      if (this.items.length === 0) return;
      const cta = e.currentTarget;
      cta.setAttribute('data-state', 'loading');
      cta.disabled = true;

      try {
        // A oferta e exclusiva: a cart validation rejeita carrinho misto (422)
        // e retry apos falha parcial duplicava linhas ate o teto de 3 pecas.
        // O kit inteiro vive no estado da pagina, entao o carrinho e SUBSTITUIDO
        // antes dos adds (clear idempotente) — com aviso quando havia itens.
        let hadItems = false;
        try {
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            hadItems = cart.item_count > 0;
          }
        } catch (_) { /* sem leitura do carrinho: limpa mesmo assim */ }

        const clearRes = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
        });
        if (!clearRes.ok) {
          throw new Error('Falha ao preparar o carrinho');
        }
        if (hadItems) this.showCartReplacedNotice();

        // batch sequencial (igual ao padrao do pdp-bundle)
        // proprieties marca line item como bundle inverno
        for (const it of this.items) {
          const formData = new FormData();
          formData.append('id', it.variantId);
          formData.append('quantity', it.qty);
          formData.append(`properties[_bundle]`, this.config.bundleTag);
          formData.append(`properties[_bundle_pieces]`, String(this.totalPieces()));
          formData.append(`properties[_bundle_discount]`, String(this.discountPercent()));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });
          const json = await response.json();
          if (response.status !== 200 || json.status) {
            const serverMsg = json.message || json.description;
            const error = new Error(serverMsg || 'Falha ao adicionar ao carrinho');
            error.bbiServerMessage = !!serverMsg;
            throw error;
          }
        }

        // Aviso de substituicao precisa de tempo de tela antes do drawer/redirect
        if (hadItems) await new Promise((resolve) => setTimeout(resolve, 900));

        // Tracking do quick shop (builder): evento próprio no dataLayer, espelho
        // em GA4 do rastro _bundle que já vai nas line properties acima (o
        // add_to_cart ecommerce padrão sai do interceptador de datalayer-push-events;
        // este só marca a ORIGEM, sem tocar no carrinho).
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'quick_shop_add_to_cart',
          method: 'bundle_builder',
          bundle_tag: this.config.bundleTag,
          bundle_pieces: this.totalPieces(),
          bundle_discount: this.discountPercent(),
          items_count: this.items.length,
          value: this.items.reduce((acc, it) => acc + it.price * it.qty, 0) / 100,
          currency: 'BRL',
        });

        // Dispara CartAddEvent SO quando existe um cart drawer NESTA pagina que
        // abre com ele (drawer + auto-open, ver #handleCartAdd do cart-drawer.js).
        // A classe window.CartAddEvent existe em TODA pagina (bundle global do
        // tema), entao testar por ela era beco sem saida nos templates up-sell:
        // o evento disparava, ninguem escutava e o cliente ficava parado com o
        // carrinho montado e sem caminho pro checkout (18/08). Sem drawer que
        // abre => navega pro ctaUrl (o proprio schema da section o descreve
        // como fallback "caso o cart drawer nao abra").
        const drawer = document.querySelector('cart-drawer-component[auto-open]');
        if (drawer && window.CartAddEvent) {
          try {
            document.dispatchEvent(new window.CartAddEvent({}, this.items[0].variantId, {
              source: 'bundle-builder-inverno',
              itemCount: this.totalPieces(),
            }));
          } catch (err) {
            console.warn('[BundleBuilderInverno] CartAddEvent falhou, redirecionando', err);
            window.location.href = this.config.ctaUrl;
          }
        } else {
          window.location.href = this.config.ctaUrl;
        }
      } catch (err) {
        console.error('[BundleBuilderInverno] erro no checkout:', err);
        // Mensagem da cart validation e acionavel (ex.: teto de pecas) — mostrar
        // ela; erro tecnico (rede/parse) mantem o generico.
        alert(err && err.bbiServerMessage
          ? err.message
          : 'Houve um problema ao adicionar ao carrinho. Tente novamente.');
      } finally {
        cta.removeAttribute('data-state');
        cta.disabled = false;
      }
    }

    showCartReplacedNotice() {
      if (document.querySelector('[data-bbi-replaced-notice]')) return;
      const notice = document.createElement('div');
      notice.setAttribute('data-bbi-replaced-notice', '');
      notice.setAttribute('role', 'status');
      notice.textContent = 'Seu carrinho anterior foi substituído pelos itens desta oferta.';
      // Estilo inline de proposito: nenhum CSS global do tema e tocado.
      notice.style.cssText = [
        'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
        'max-width:calc(100vw - 32px)', 'padding:12px 18px', 'border-radius:10px',
        'background:#111', 'color:#fff', 'font-size:14px', 'line-height:1.4',
        'text-align:center', 'box-shadow:0 4px 18px rgba(0,0,0,.35)',
        'z-index:2147483000', 'pointer-events:none',
      ].join(';');
      document.body.appendChild(notice);
      setTimeout(() => notice.remove(), 5000);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function escapeAttr(str) {
    return escapeHtml(str);
  }

  function init() {
    const roots = document.querySelectorAll(`.${SCOPE}`);
    roots.forEach((root) => {
      if (root.dataset.bbiInited === 'true') return;
      root.dataset.bbiInited = 'true';
      new BundleBuilderInverno(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init quando o tema re-renderiza sections (Theme Editor)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector(`.${SCOPE}`)) {
      init();
    }
  });

  window.BundleBuilderInverno = BundleBuilderInverno;
})();
